import {
  GET_ORDERS_SUCCESS,
  GET_ORDERS_FAIL,
  GET_ORDER_SUCCESS,
  GET_ORDER_FAIL,
  UPDATE_ORDER_STATUS_SUCCESS,
  UPDATE_ORDER_STATUS_FAIL,
  ORDER_CONFIRMATION_SUCCESS,
  ORDER_CONFIRMATION_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  orders: [],
  selectedOrder: null,
  loading: false,
  error: null,
  pagination: {
    pageIndex: 0,
    pageSize: 10,
    totalCount: 0,
    totalPages: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  },
  updateSuccess: false,
  confirmationSuccess: false,
}

const OrdersReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Get all orders
    case "GET_ORDERS":
      return {
        ...state,
        loading: true,
        error: null,
      }

    case GET_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        orders: action.payload.items || [],
        pagination: {
          pageIndex: action.payload.pageIndex || 0,
          pageSize: action.payload.pageSize || 10,
          totalCount: action.payload.totalCount || 0,
          totalPages: action.payload.totalPages || 0,
          hasPreviousPage: action.payload.hasPreviousPage || false,
          hasNextPage: action.payload.hasNextPage || false,
        },
        error: null,
      }

    case GET_ORDERS_FAIL:
      return {
        ...state,
        loading: false,
        orders: [],
        error: action.payload,
      }

    // Get single order
    case "GET_ORDER":
      return {
        ...state,
        loading: true,
        selectedOrder: null,
        error: null,
      }

    case GET_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedOrder: action.payload,
        error: null,
      }

    case GET_ORDER_FAIL:
      return {
        ...state,
        loading: false,
        selectedOrder: null,
        error: action.payload,
      }

    // Update order status
    case "UPDATE_ORDER_STATUS":
      return {
        ...state,
        loading: true,
        updateSuccess: false,
        error: null,
      }

    case UPDATE_ORDER_STATUS_SUCCESS:
      // Update the order in the list with the fetched data
      const updatedOrder = action.payload
      return {
        ...state,
        loading: false,
        updateSuccess: true,
        orders: state.orders.map(order =>
          order.id === updatedOrder.id ? updatedOrder : order
        ),
        selectedOrder: state.selectedOrder?.id === updatedOrder.id
          ? updatedOrder
          : state.selectedOrder,
        error: null,
      }

    case UPDATE_ORDER_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        updateSuccess: false,
        error: action.payload,
      }

    // Order confirmation
    case "ORDER_CONFIRMATION":
      return {
        ...state,
        loading: true,
        confirmationSuccess: false,
        error: null,
      }

    case ORDER_CONFIRMATION_SUCCESS:
      // Update the order in the list with the fetched data
      const confirmedOrder = action.payload
      return {
        ...state,
        loading: false,
        confirmationSuccess: true,
        orders: state.orders.map(order =>
          order.id === confirmedOrder.id ? confirmedOrder : order
        ),
        selectedOrder: state.selectedOrder?.id === confirmedOrder.id
          ? confirmedOrder
          : state.selectedOrder,
        error: null,
      }

    case ORDER_CONFIRMATION_FAIL:
      return {
        ...state,
        loading: false,
        confirmationSuccess: false,
        error: action.payload,
      }

    default:
      return state
  }
}

export default OrdersReducer
